import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import * as React from 'react'
import {forwardRef,} from 'react'
import {PALETTE} from '../../styles/paletteV3'
import {FONT_FAMILY} from '../../styles/typographyV2'
import StyledError from '../StyledError'

const Input = styled('input')({
  appearance: 'none',
  borderWidth: 0,
  borderBottom: `1px solid ${PALETTE.SLATE_400}`,
  borderRadius: 0,
  boxShadow: 'none',
  color: PALETTE.SLATE_700,
  display: 'block',
  fontFamily: FONT_FAMILY.SANS_SERIF,
  fontSize: 14,
  lineHeight: '1.375rem',
  margin: 0,
  outline: 0,
  padding: '.3125rem 1rem .3125rem 0',
  width: '100%',
  ':hover,:focus,:active': {
    borderColor: PALETTE.GRAPE_700
  }
})

const ErrorMessage = styled(StyledError)({
  fontSize: '.8125rem',
  marginTop: '.5rem'
})















const UnderlineInput = forwardRef((props, ref) => {
  const {
    ariaLabel,
    autoComplete,
    autoFocus,
    disabled,
    error,
    name,
    onBlur,
    onChange,
    placeholder,
    type = 'text',
    value
  } = props
  return (
    _jsxs(React.Fragment, { children: [
      _jsx(Input, {
        'aria-label': ariaLabel,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        disabled: Boolean(disabled),
        ref: ref,
        name: name,
        placeholder: placeholder,
        onBlur: onBlur,
        onChange: onChange,
        type: type,
        value: value,}
      )
      , error && _jsx(ErrorMessage, { children: error})
    ]})
  )
})

export default UnderlineInput
